import { CreateActionParams } from '../actions';
import { SelectedAddons } from '../../../../utils/state/types';

export type OnAddonSelect = (
  addonId: string,
  isSelected: boolean,
  serviceSlotId: string,
) => void;

export function createOnAddonSelectAction({
  getControllerState,
  internalActions: { calculatePaymentDetails, updateServiceSlot },
}: CreateActionParams): OnAddonSelect {
  return async (
    addonId: string,
    isSelected: boolean,
    serviceSlotId: string,
  ) => {
    const [state] = getControllerState();
    const { serviceData } = state;
    const slotService = serviceData.slotServices[serviceSlotId];
    const group = slotService.addOnByGroup?.find((g) =>
      g.addOns?.some((a) => a.id === addonId),
    );

    if (!group) {
      return;
    }

    const addon = group.addOns?.find((a) => a.id === addonId);
    if (!addon) {
      return;
    }

    const currentSelectedAddons = slotService.selectedAddons || {};
    let newSelectedAddons: SelectedAddons = { ...currentSelectedAddons };
    const groupId = group.id!;

    if (isSelected) {
      // Check if we can add more addons based on the group's limit
      const totalSelectedAddons = Object.values(currentSelectedAddons).reduce(
        (count, groupAddons) => count + Object.keys(groupAddons).length,
        0,
      );

      if (
        group.maxNumberOfAddOns &&
        totalSelectedAddons >= group.maxNumberOfAddOns
      ) {
        return;
      }

      if (!newSelectedAddons[groupId]) {
        newSelectedAddons[groupId] = {};
      }

      newSelectedAddons[groupId][addonId] = {
        id: addon.id!,
        quantity: 1,
        price: addon.price,
        currency: addon.currency,
      };
    } else {
      if (newSelectedAddons[groupId]?.[addonId]) {
        const { [addonId]: _, ...restGroupAddons } = newSelectedAddons[groupId];
        if (Object.keys(restGroupAddons).length === 0) {
          const { [groupId]: __, ...restGroups } = newSelectedAddons;
          newSelectedAddons = restGroups;
        } else {
          newSelectedAddons[groupId] = restGroupAddons;
        }
      }
    }

    updateServiceSlot(
      {
        selectedAddons: newSelectedAddons,
      },
      serviceSlotId,
    );

    await calculatePaymentDetails({});
  };
}
